import { useTranslation } from 'react-i18next';

import { BillingPeriod } from '@/features/subscriptions/types/subscription-types';
import { Badge } from '@/shared/components/ui/badge';
import { Switch } from '@/shared/components/ui/switch';

interface BillingPeriodToggleProps {
  billingPeriod: BillingPeriod;
  onBillingPeriodChange: (period: BillingPeriod) => void;
}

export const BillingPeriodToggle = ({
  billingPeriod,
  onBillingPeriodChange,
}: BillingPeriodToggleProps) => {
  const { t } = useTranslation('subscriptions');

  const isYearly = billingPeriod === 'yearly';

  function handleToggle() {
    onBillingPeriodChange(isYearly ? 'monthly' : 'yearly');
  }

  return (
    <div className="flex items-center gap-4">
      <span className="text-sm font-medium transition-colors">
        {t('billing.monthly')}
      </span>
      <Switch checked={isYearly} onCheckedChange={handleToggle} />
      <span className="text-sm font-medium transition-colors">
        {t('billing.yearly')}
      </span>
      <Badge
        variant={'outline'}
        className="rounded-full border-[hsl(271_91%_65%/0.2)] !bg-[hsl(271_91%_65%/0.2)] px-3 py-1 text-xs font-medium text-[hsl(270_95%_75%)]"
      >
        {t('billing.save')}
      </Badge>
    </div>
  );
};
